import { render, staticRenderFns } from "./saleDetail.vue?vue&type=template&id=0ef24e1f&scoped=true&"
import script from "./saleDetail.vue?vue&type=script&lang=js&"
export * from "./saleDetail.vue?vue&type=script&lang=js&"
import style0 from "./saleDetail.vue?vue&type=style&index=0&id=0ef24e1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef24e1f",
  null
  
)

export default component.exports